export default __webpack_public_path__ + "static/icon-sustain-6859914ccfb9b2418fceb334466e18d7.png";